import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private messageService: MessageService) { }

  sucesso(title: string, message: string){
    this.messageService.add({severity: 'success', summary: title, detail: message});
  }

  erro(title: string, message: string){
    this.messageService.add({severity: 'error', summary: title, detail: message});
  }

  info(title: string, message: string){
    this.messageService.add({severity: 'info', summary: title, detail: message});
  }

  alerta(title: string, message: string){
    this.messageService.add({severity: 'warn', summary: title, detail: message});
  }
}
